export default __webpack_public_path__ + "static/michael-43040bbdbcbf349d98008801b886548e.jpg";